import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import GermanAustrianAdvantagesSection from './components/GermanAustrianAdvantagesSection';
import TestimonialSection from './components/TestimonialSection';
import ProgramSection from './components/ProgramSection';
import RegistrationSection from './components/RegistrationSection';
import Footer from './components/Footer';
import { useState, useEffect } from 'react';

export default function Home() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [mobileMenuOpen]);

  return (
    <div className="min-h-screen">
      <nav className="bg-white shadow-md sticky top-0 z-50 transition-all duration-300" id="main-nav">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4">
          <div className="flex items-center justify-between">
            <a href="/" className="text-xl sm:text-2xl font-bold text-gray-900">
              Dubai <span className="text-yellow-500">Business Club</span>
            </a>
            
            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8">
              <a href="/" className="text-gray-700 hover:text-yellow-500 transition-colors font-medium whitespace-nowrap">
                Startseite
              </a>
              <a href="/masterclass" className="text-gray-700 hover:text-yellow-500 transition-colors font-medium whitespace-nowrap">
                Dubai Masterclass
              </a>
              <a href="#bewerbung" className="bg-gradient-to-r from-yellow-500 to-yellow-600 hover:from-yellow-600 hover:to-yellow-700 text-white px-6 py-2 rounded-full font-bold transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer">
                Jetzt bewerben
              </a>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="md:hidden w-10 h-10 flex items-center justify-center text-gray-700 hover:text-yellow-500 transition-colors cursor-pointer"
              aria-label="Menü öffnen"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-100">
              <div className="flex flex-col p-4 space-y-4">
                <a 
                  href="/" 
                  className="text-gray-700 hover:text-yellow-500 transition-colors font-medium py-2 cursor-pointer"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Startseite
                </a>
                <a 
                  href="/masterclass" 
                  className="text-gray-700 hover:text-yellow-500 transition-colors font-medium py-2 cursor-pointer"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Dubai Masterclass
                </a>
                <a 
                  href="#bewerbung" 
                  className="bg-gradient-to-r from-yellow-500 to-yellow-600 text-white px-6 py-3 rounded-full font-bold text-center cursor-pointer"
                  onClick={() => setMobileMenuOpen(false)}
                >
                  Jetzt bewerben
                </a>
              </div>
            </div>
          )}
        </div>
      </nav>
      <HeroSection />
      <AboutSection />
      <GermanAustrianAdvantagesSection />
      <TestimonialSection />
      <ProgramSection />
      <RegistrationSection />
      <Footer />
    </div>
  );
}
